<template>
  <div class="page-wrapper">

    <div id="kr-wrapper" @click="getMousePosition"></div>
    <!-- 顶部 按钮组-->
    <!-- <TopMenu /> -->
    <!-- 底部按钮 -->
    <!-- <BottomMenu :kr="krpano"/> -->
    <!-- 吉祥物位置 -->
    <!-- <span class="mascot-icon"></span> -->
    <KrDesign v-if="showDesign" :selectHotSpot="selectHotSpot" :selectRadar="selectRadar" />
  </div>
</template>

<script>
import TopMenu from '@/components/kr/TopMenu'
import PopupInfo from '@/components/kr/PopupInfo'
import PopupComInfo from '@/components/kr/PopupComInfo'
import cgz from '@/components/kr/cgz'
import qyz from '@/components/kr/qyz'
import yzh from '@/components/kr/yzh'
// import LiveList from '@/components/live/LiveList'
// import Meeting1 from '@/common/Meeting1'
// import Meeting2 from '@/common/Meeting2'
import Rank from '@/common/Rank'
import Game from '@/common/Game'
import Base from '@/common/Base'
import Live from '@/common/Live'
import Search from '@/common/Search'
import VodList from '@/common/VodList'
import ImageView from '@/common/ImageView'
import ImgView from '@/common/ImgView'
import PdfView from '@/common/PdfView'
import PopupBigMap from '@/components/kr/PopupBigMap'
import PosterView from '@/common/PosterView'
import TextView from '@/common/TextView'
import VideoView from '@/common/VideoView'
import Share from '@/components/kr/Share'
import ShowDetail from '@/components/youth_science/ShowDetail'
import Vue from 'vue'
// import BottomMenu from '@/components/kr/BottomMenu'
import KrDesign from '@/components/kr/KrDesign'
export default {
  name: 'KrpanoView',
  components: { KrDesign },
  data() {
    return {
      krpano: null,
      showDesign: false,
      currentScene: 'total_view',
      willTo: '',
      selectHotSpot: '',
      selectRadar: ''
    }
  },
  created() {
    if (this.$route.query && this.$route.query.scene) {
      this.willTo = this.$route.query.scene
      this.$router.push({ name: 'kr_view' })
    }
    window.showDesign = this.openDesign
    window.closeDesign = this.closeDesign
  },
  mounted() {
    window.krEvent = this.krEvent
    // let currentH = new Date().getHours();
    // let isDay = 6 < currentH && currentH < 18;
    // let tourxml = isDay ? 'tour.xml' : 'tour_night.xml'
    let tourxml = 'tour.xml';
    if (this.currentLang == 'en') {
      // tourxml = isDay ? 'tour_en.xml' : 'tour_en_night.xml'
      tourxml = 'tour_en.xml';
    }
    /* eslint-disable */
    embedpano({
      swf: "https://cdnzyzs.secsa.cn/qingbohuizs/2024/krpano.swf",
      xml: "https://cdnzyzs.secsa.cn/qingbohuizs/2024/youth/" + tourxml,

      // swf: "/krpano.swf",
      // xml: "/youth/" + tourxml,
      target: "kr-wrapper",
      html5: "auto",
      mobilescale: 1.0,
      passQueryParameters: true,
      onready: this.krpanoReady
    })
    /* eslint-enable */
  },
  methods: {
    openDesign() {
      this.showDesign = true
    },
    closeDesign() {
      this.showDesign = false
    },
    krpanoReady(krpanoInstance) {
      this.krpano = krpanoInstance
      window.krpano = krpanoInstance
      if (this.willTo) {
        // this.krpano.call(`loadscene(${this.willTo})`)
        this.krpano.call(`radarspot_loadscene(${this.willTo.toLowerCase()})`)
        this.krpano.call(`skin_showskin())`)
      }
    },
    krEvent(evName, value) {

      console.log(evName, value)
      if (evName === 'popupSearch') {

        new Vue({
          render: h => h(Search, { props: { popInKr: true, searchItem: value } }),
        }).$mount('#pop-id')

      } else if (evName === 'sceneWillClose') {

        console.log('a')

      } else if (evName === 'sceneWillLoad') {
        if (this.currentScene !== value) {
          this.$router.push({ name: 'kr_view', query: { scene: value } })
          this.currentScene = value
        }
      } else if (evName === 'popupText') {

        // if (value.indexOf('E') >= 0 || value.indexOf('F') >= 0 || value.indexOf('B') >= 0 || value.indexOf('C') >= 0 || value.indexOf('D') >= 0) {
        //   new Vue({
        //     render: h => h(TextView, { props: { popInKr: true, id: value } }),
        //   }).$mount('#pop-id')
        //   return
        // }
        new Vue({
          render: h => h(TextView, { props: { popInKr: true, id: value } }),
        }).$mount('#pop-id')
        return

      } else if (evName === 'popupPdf') {

        // if (value.indexOf('E') >= 0 || value.indexOf('F') >= 0 || value.indexOf('B') >= 0 || value.indexOf('C') >= 0 || value.indexOf('D') >= 0) {
        //   new Vue({
        //     render: h => h(PdfView, { props: { popInKr: true, id: value } }),
        //   }).$mount('#pop-id')
        //   return
        // }
        new Vue({
          render: h => h(PdfView, { props: { popInKr: true, id: value } }),
        }).$mount('#pop-id')
        return

      } else if (evName === 'popupPoster') {

        if (value.indexOf('E') >= 0 || value.indexOf('F') >= 0 || value.indexOf('B') >= 0 || value.indexOf('C') >= 0 || value.indexOf('D') >= 0) {
          new Vue({
            render: h => h(PosterView, { props: { popInKr: true, id: value } }),
          }).$mount('#pop-id')
          return
        }

      } else if (evName === 'popupVideo') {

        if (this.selectHotSpot === 's-01-hot-4') {
          new Vue({
            render: h => h(VideoView, { props: { popInKr: true, url: 'https://cdnzyzs.secsa.cn/qingbohuizs/2024/2024qbhxuanchuanpian.mp4' } }),
          }).$mount('#pop-id')
          return
        } else if (this.selectHotSpot === 'h-001-hot-3') {
          new Vue({
            render: h => h(ShowDetail, { props: { popInKr: true } }),
          }).$mount('#pop-id')
          return;
        } else if (this.selectHotSpot === 'h-001-hot-6') {
          new Vue({
            render: h => h(Live, { props: { popInKr: true } }),
          }).$mount('#pop-id')
          return
        } else if (this.selectHotSpot === 'h-001-hot-5') {
          new Vue({
            render: h => h(VodList, { props: { popInKr: true } }),
          }).$mount('#pop-id')
          return
        } else {
          new Vue({
            render: h => h(VideoView, { props: { popInKr: true, id: value } }),
          }).$mount('#pop-id')
        }

        // if (value.indexOf('E') >= 0 || value.indexOf('F') >= 0 || value.indexOf('B') >= 0 || value.indexOf('C') >= 0 || value.indexOf('D') >= 0 || value.indexOf('Z') >= 0) {
        //   new Vue({
        //     render: h => h(VideoView, { props: { popInKr: true, id: value } }),
        //   }).$mount('#pop-id')
        //   return
        // }

      } else if (evName === 'popupImg') {

        if (this.selectHotSpot === 'd-001-hot-3') {
          new Vue({
            render: h => h(Base, { props: { popInKr: true } }),
          }).$mount('#pop-id')
          return
        } else if (this.selectHotSpot === 'd-01-hot-21') {
          // 明日之星序言
          new Vue({
            render: h => h(ImageView, { props: { popInKr: true, imgUrl: this.currentLang == 'cn' ? 'https://cdn.shsunshine.org/qbh/img/2022qbh/mrzx/序言_cn.gif' : 'https://cdn.shsunshine.org/qbh/img/2022qbh/mrzx/序言_en.gif' } }),
          }).$mount('#pop-id')
          return
        } else if (this.selectHotSpot === 'bc-000-hot-3') {
          // 大屏地图
          new Vue({
            render: h => h(ImageView, { props: { popInKr: true, imgUrl: 'https://cdn.shsunshine.org/qbh/XZ/BC序厅.jpg' } }),
          }).$mount('#pop-id')
          return
        } else {
          new Vue({
            render: h => h(ImgView, { props: { popInKr: true, id: value } }),
          }).$mount('#pop-id')
          return
        }

        // if (value.indexOf('E') >= 0 || value.indexOf('F') >= 0 || value.indexOf('B') >= 0 || value.indexOf('C') >= 0 || value.indexOf('D') >= 0 || value.indexOf('X') >= 0) {
        //   new Vue({
        //     render: h => h(ImgView, { props: { popInKr: true, id: value } }),
        //   }).$mount('#pop-id')
        //   return
        // }

      } else if (evName === 'popupInfo') {
        value = value.toUpperCase()
        if (this.selectHotSpot == 's-03-hot-4') {
          // 成果展
          new Vue({
            render: h => h(cgz, { props: { popInKr: true, hotspot: this.selectHotSpot } }),
          }).$mount('#pop-id')
          return
        } else if (this.selectHotSpot === 's-04-hot-4') {
          // 企业展
          new Vue({
            render: h => h(qyz, { props: { popInKr: true, hotspot: this.selectHotSpot } }),
          }).$mount('#pop-id')
          return
        } else if (this.selectHotSpot === 's-02-hot-4') {
          // 圆桌
          new Vue({
            render: h => h(yzh, { props: { popInKr: true, hotspot: this.selectHotSpot } }),
          }).$mount('#pop-id')
          return
        } else if (value.indexOf('A') >= 0) {
          new Vue({
            render: h => h(PopupInfo, { props: { popInKr: true, id: value } }),
          }).$mount('#pop-id')
          return
        } else {
          new Vue({
            render: h => h(PopupComInfo, { props: { popInKr: true, id: value } }),
          }).$mount('#pop-id')
          return
        }


        // if (['s-03-hot-4', 's-03-hot-5', 's-07-hot-3', 's-07-hot-4'].indexOf(this.selectHotSpot) !== -1) {
        //   // 互动体验
        //   new Vue({
        //     render: h => h(Game, { props: { popInKr: true, hotspot: this.selectHotSpot } }),
        //   }).$mount('#pop-id')
        //   return
        // }

        // if (this.selectHotSpot === 's-07-hot-5') {
        //   // 网络峰会
        //   new Vue({
        //     render: h => h(Meeting1, { props: { popInKr: true } }),
        //   }).$mount('#pop-id')
        //   return
        // } else if (this.selectHotSpot === 's-07-hot-6') {
        //   // 直播活动
        //   new Vue({
        //     render: h => h(LiveList, { props: { popInKr: true } }),
        //   }).$mount('#pop-id')
        //   return
        // }

        // if (value.indexOf('A') >= 0 || value.indexOf('a') >= 0 || value.indexOf('D') >= 0) {
        //   value = value.toUpperCase()
        //   new Vue({
        //     render: h => h(PopupInfo, { props: { popInKr: true, id: value } }),
        //   }).$mount('#pop-id')
        // }
        // else if (value.indexOf('E') >= 0 || value.indexOf('F') >= 0 || value.indexOf('B') >= 0 || value.indexOf('C') >= 0) {
        //   new Vue({
        //     render: h => h(PopupComInfo, { props: { popInKr: true, id: value } }),
        //   }).$mount('#pop-id')
        // }

      } else if (evName === 'addTopMenu') {
        new Vue({
          render: h => h(TopMenu),
        }).$mount('#top-menu')
      } else if (evName === 'rank') {
        new Vue({
          render: h => h(Rank, { props: { popInKr: true } }),
        }).$mount('#pop-id')
      } else if (evName === 'game') {
        new Vue({
          render: h => h(Game, { props: { popInKr: true } }),
        }).$mount('#pop-id')
      } else if (evName === 'share') {
        new Vue({
          render: h => h(Share, { props: { popInKr: true } }),
        }).$mount('#pop-id')
      } else if (evName === 'selectHotSpot') {
        this.selectHotSpot = value
      } else if (evName === 'selectRadar') {
        this.selectRadar = value
      }
      else if (evName === 'popupBigMap') {

        // if (value.indexOf('E') >= 0 || value.indexOf('F') >= 0 || value.indexOf('B') >= 0 || value.indexOf('C') >= 0 || value.indexOf('D') >= 0) {
        new Vue({
          render: h => h(PopupBigMap, { props: { popInKr: true, id: value } }),
        }).$mount('#pop-id')
        return
        // }

      }
    },
    getMousePosition() {
      let x = this.krpano.get('mouse.x')
      let y = this.krpano.get('mouse.y')
      let screentosphere = this.krpano.screentosphere(x, y)
      let h = screentosphere.x
      let v = screentosphere.y
      let fov = this.krpano.get("view.fov")
      console.log('mouseX: ' + x, 'mouseY: ' + y, 'h: ' + h, 'v: ' + v, 'fov: ' + fov)
      // add hotsport
      // let spName = 'sp_' + new Date().getTime()
      // this.krpano.call(`addhotspot(${spName})`,)
      // this.krpano.set(`hotspot[${spName}].url`, './youth/skin/vtourskin_hotspot.png')
      // this.krpano.set(`hotspot[${spName}].ath`, h)
      // this.krpano.set(`hotspot[${spName}].atv`, v)
      // this.krpano.set(`hotspot[${spName}].distorted`, true)
    }
  }
}
</script>
<style scoped>
.page-wrapper {
  width: 100%;
  height: 100vh;
  position: relative;
}

#kr-wrapper {
  width: 100%;
  height: 100%;
}

.button-wrapper {
  position: absolute;
  bottom: 0px;
}

.button-wrapper span {
  cursor: pointer;
  color: #ffffff;
}

.mascot-icon {
  width: 7rem;
  height: 8rem;
  left: 4rem;
  bottom: 4rem;
  position: absolute;
  background-image: url(../assets/krpano_icon/mascot.png);
  background-size: 100% 100%;
  cursor: pointer;
}
</style>
